import type { AssetType } from '@seek/brand-types';
import type { UploadNewAssetParams } from '@seek/image-service-types';
import setDebug from 'debug';

import { callImageService } from '../utils/fetchAsset';
import { getAssetStrategies } from '../utils/getAssetStrategies';

const debug = setDebug('image-service-uploader');

interface UploadAssetParams extends UploadNewAssetParams {
  type: AssetType;
}

export const uploadAsset = async ({
  type,
  file,
  croppedInfo,
}: UploadAssetParams) => {
  const formData = new FormData();
  const strategies = getAssetStrategies(type, croppedInfo);

  formData.append('image', file);
  formData.append('metadata', JSON.stringify({ usage: type }));
  formData.append('strategies', JSON.stringify(strategies));

  debug(`Uploading ${type}`);

  const response = await callImageService({ body: formData });

  if (!response.ok) {
    const resp = await response.json();
    debug(`Failed to upload ${type} to image-service`);
    throw new Error(resp.message);
  }

  return response.json();
};
